import type { Activity } from "@/services/api/cronos/activities/get"
import { generateDateArray, getLastMonday } from "../utils/time"
import { isSameDay } from "date-fns"
import { convertToSeconds } from "@/shared/utils/time"
import type { Activities } from "./activities"

export function groupActivitiesByWeekday(activities: Activity[]): Activities[] {
  const lastMonday = getLastMonday()
  const weeks = generateDateArray(lastMonday, 13).map((day) => {
    const weekStart = new Date(day)

    const activitiesThisDay = activities.filter((activity) => {
      const activityDate = new Date(activity.dateTime)
      const selectedDate = new Date(day)

      return isSameDay(activityDate, selectedDate)
    })

    const filteredActivities = activitiesThisDay.filter((a) => {
      if (a.status === "rescheduled") {
        return false
      }

      return true
    })

    const totalSeconds = filteredActivities.reduce((total, activity) => {
      return total + (convertToSeconds(activity.estimatedDuration) || 0)
    }, 0)

    return {
      id: Math.random().toString(36).substr(2, 9),
      day: new Intl.DateTimeFormat("es-AR", { weekday: "long" }).format(weekStart),
      date: day,
      totalSeconds,
      isRescheduled: false,
      activities: filteredActivities,
    }
  })

  const activitiesRescheduleds = activities.filter((activity) => activity.status === "rescheduled")

  weeks.splice(7, 0, {
    id: Math.random().toString(36).substr(2, 9),
    date: "",
    day: "",
    totalSeconds: 0,
    activities: activitiesRescheduleds,
    isRescheduled: true,
  })

  return weeks
}

export function getActivitiesOfFirstWeek(activities: Activities[]): Activities[] {
  const arr = [...activities]
  return arr.slice(0, 8)
}

export function getActivitiesOfNextWeek(activities: Activities[]): Activities[] {
  const arr = [...activities]
  return arr.slice(7, 14)
}
